import { Component } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { BuildDetailsComponent } from '../build-details/build-details.component';

@Component({
  selector: 'app-build-info-button',
  templateUrl: './build-info-button.component.html',
  styleUrls: ['./build-info-button.component.less']
})
export class BuildInfoButtonComponent {
  constructor(private modal: NzModalService) {}

  openBuildDetails(): void {
    this.modal.create({
      nzTitle: 'Build Details',
      nzContent: BuildDetailsComponent,
      nzFooter: null,
      nzWidth: 800
    });
  }
}
